import shave from 'shave';

(function (Drupal) {
	Drupal.behaviors.newsItemCarousel = {
		attach: function (context, settings) {

			const shaveElements = function (element) {
				const truncate = element.querySelectorAll("[data-shave]");
				truncate.forEach(el => {
					// get the text element to shave
					let shaveValue = el;
					const selector = el.getAttribute("data-shave-selector");
					if (selector) {
						shaveValue = el.querySelector(selector);
					}

					// if no shaveValue, return
					if (!shaveValue) {
						return;
					}

					// get element max-height based on the number of lines and line-height
					const linesNbr = el.getAttribute("data-shave-lines") ?? 1;
					const linesNbrSm = el.getAttribute("data-shave-sm-lines") ?? linesNbr;
					const linesNbrXl = el.getAttribute("data-shave-xl-lines") ?? linesNbrSm;

					let lines = parseInt(linesNbr);
					if (window.innerWidth >= 644) {
						lines = parseInt(linesNbrSm);
					}
					if (window.innerWidth >= 1459) {
						lines = parseInt(linesNbrXl);
					}

					const lineHeight = parseInt(getComputedStyle(shaveValue).lineHeight);
					const maxHeight = (lineHeight * lines) + (lineHeight / 2);
					
					// shave the element
					if (shaveValue) {
						shave(shaveValue, maxHeight);
					}
				});
			}

			once('news-item-content--carousel-news', '.news-item-content--carousel-news', context).forEach(function (item) {
				shaveElements(item);
			
				let timer = null;
				window.addEventListener("resize", function () {
					clearTimeout(timer);
					timer = setTimeout(function() {
						shaveElements(item);
					}, 100);
				});
			});
		}
	};
})(Drupal);
